import React from "react";
import {Link} from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';

const DigitalInnovationCurriculum = () => {
  const styles = {
    body: {
      fontFamily: "'Arial', sans-serif",
      color: "#333",
      lineHeight: 1.6,
      margin: 0,
      padding: 0,
      scrollBehavior: "smooth",
    },
    h1: {
      textAlign: "center",
      color: "white",
      margin: "40px 0",
      padding: "10px",
      textTransform: "uppercase",
      letterSpacing: "1px",
      background: "linear-gradient(to right, #FF6F61, #FFD700)",
      borderRadius: "10px",
    },
    ul: {
      listStyleType: "none",
      paddingLeft: 0,
    },
    li: {
      backgroundColor: "#fff",
      margin: "15px 0",
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
      transition: "all 0.3s ease-in-out",
    },
    liHover: {
      transform: "translateY(-5px)",
      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    },
    ol: {
      marginTop: "10px",
      paddingLeft: "20px",
    },
    olLi: {
      margin: "8px 0",
    },
    i: {
      fontStyle: "italic",
      color: "#007bff",
    },
    signupSection: {
      textAlign: "center",
      margin: "40px 0",
    },
    signupIframe: {
      borderRadius: "10px",
      border: "none",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    },
    videoSection: {
      marginTop: "40px",
      textAlign: "center",
    },
    videoIframe: {
      width: "100%",
      maxWidth: "960px",
      minHeight: "350px",
      maxHeight: "540px",
      border: "none",
      borderRadius: "10px",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    },
    metaSection: {
      textAlign: "center",
      marginTop: "50px",
      fontStyle: "italic",
      fontSize: "1.2em",
      color: "#777",
    },
  };

  return (
    <div className="container">
      <ScrollToTop />
      <div style={styles.body}>
      <h1 style={styles.h1}>WHAT IS CONTAINED IN THIS HTML COURSE</h1>
      <ul style={styles.ul}>
        <li style={styles.li}>
          HTML Basics
          <ol style={styles.ol}>
            <li style={styles.olLi}>
              <i style={styles.i}>What is HTML?</i>
            </li>
            <li style={styles.olLi}>
              <i style={styles.i}>How to write, open, and edit HTML</i>
            </li>
            <li style={styles.olLi}>
              <i style={styles.i}>HTML Elements</i>
            </li>
            <li style={styles.olLi}>
              <i style={styles.i}>Types of HTML Elements</i>
            </li>
          </ol>
        </li>
        {/* Add other list items similarly */}
      </ul>

      {/* Video Embed Section */}
      <div style={styles.videoSection}>
        <h2>Embedding videos</h2>
        <iframe
          src="https://www.youtube.com/embed/SiCTXSwqzkw?si=yQjXTdY3IqY_G7bs&autoplay=1&mute=1"
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={styles.videoIframe}
        ></iframe>
      </div>
      <div style={styles.signupSection}>
      <Link to="/programs/learn-coding/questionnaire" className='btn-modern btn-primary text-decoration-none mt-4'>
        <i className="bi bi-person-plus me-2"></i>
        Register here
      </Link>
      </div>
      {/* Meta Section */}
      <div style={styles.metaSection}>
        <p>
          <i style={styles.i}>
            Page designed to educate kids in Kenya about HTML and digital
            innovation.
          </i>
        </p>
      </div>
    </div>
    </div>
  );
};

export default DigitalInnovationCurriculum;
